import { render } from "./RoundedButtons.vue?vue&type=template&id=33da0cac&ts=true"
import script from "./RoundedButtons.vue?vue&type=script&lang=ts"
export * from "./RoundedButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__